module.exports = __webpack_public_path__ + "img/horizon.2dd09260.png";